const PUBLIC_URL = process.env.PUBLIC_URL;

export const backgroundCirclesImage = PUBLIC_URL + '/images/sphere_bg_cut.png';
export const backgroundImage = PUBLIC_URL + '/images/bg_img.png';
export const gdrpPrivacyPolicyPdf =
  PUBLIC_URL + '/documents/GDPR_Privacy_Policy.pdf';
export const logoSvg = PUBLIC_URL + '/svgs/LOGO.svg';
export const privacyPolicyPdf = PUBLIC_URL + '/documents/privacy_policy.pdf';
export const termOfUsePdf = PUBLIC_URL + '/documents/terms_of_use.pdf';
